import React, { createContext, useContext, useMemo } from "react";
import ar from "./ar.json";
import en from "./en.json";

const dictionaries = { ar, en };
const I18nContext = createContext({ lang: "ar", t: (k) => k, dict: ar });

function getByPath(obj, path) {
  return path.split(".").reduce((acc, key) => {
    if (acc == null) return undefined;
    return acc[key];
  }, obj);
}

export function I18nProvider({ lang, children }) {
  const value = useMemo(() => {
    const dict = dictionaries[lang] || dictionaries.ar;
    const t = (key) => {
      const v = getByPath(dict, key);
      return v == null ? key : v;
    };
    return { lang, t, dict };
  }, [lang]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}

export const SUPPORTED_LANGS = ["ar", "en"];
export const DEFAULT_LANG = "ar";
